import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetJobs(payload) {
    return Api().get(`${API_VERSION}/webapp/jobs/jobs`);
  },
  GetJob(payload) {
    return Api().get(`${API_VERSION}/webapp/jobs/jobs/${payload.job_id}`);
  },
  GetJobRoles(payload) {
    return Api().get(`${API_VERSION}/webapp/jobs/roles`);
  },
  GetJobDepartments(payload) {
    return Api().get(`${API_VERSION}/webapp/jobs/departments`);
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/JobService.js